import { memo } from "react"

const IconInfoCard = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.86065 5.3587C7.60497 5.38817 7.41201 5.60466 7.41201 5.86203C7.41201 6.11941 7.60497 6.33589 7.86065 6.36536C7.99499 6.36723 8.12427 6.31423 8.21864 6.2186C8.31301 6.12297 8.3643 5.993 8.36065 5.8587C8.35706 5.58406 8.13529 5.36229 7.86065 5.3587Z"
        fill="#818181"
      />
      <path
        d="M7.86065 7.2787C7.7275 7.27689 7.59926 7.32898 7.5051 7.42315C7.41094 7.51731 7.35884 7.64554 7.36065 7.7787V9.8587C7.36065 10.1348 7.58451 10.3587 7.86065 10.3587C8.13679 10.3587 8.36065 10.1348 8.36065 9.8587V7.79203C8.36425 7.65713 8.31316 7.5265 8.219 7.42983C8.12484 7.33315 7.9956 7.27865 7.86065 7.2787Z"
        fill="#818181"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.86065 1.33203C4.2576 1.33571 1.33766 4.25564 1.33398 7.8587C1.33398 11.4633 4.25607 14.3854 7.86065 14.3854C11.4652 14.3854 14.3873 11.4633 14.3873 7.8587C14.3836 4.25564 11.4637 1.33571 7.86065 1.33203ZM7.86065 13.3854C4.80836 13.3854 2.33398 10.911 2.33398 7.8587C2.33398 4.8064 4.80836 2.33203 7.86065 2.33203C10.9129 2.33203 13.3873 4.8064 13.3873 7.8587C13.3836 10.9095 10.9114 13.3817 7.86065 13.3854Z"
        fill="#818181"
      />
    </svg>
  )
}

export default memo(IconInfoCard)
